/* eslint-disable eslint-comments/no-restricted-disable, @atlassian/react-entrypoint/no-imports-in-entrypoint-file */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import { fg } from '@atlassian/jira-feature-gating';
import type {
	WorkItemLazyQueryWrapperEntryPointParams,
	WorkItemLazyQueryWrapperProps,
} from './WorkItemLazyQueryWrapper.entrypoint.types.tsx';
import workItemLazyQueryWrapperEntrypointContentQueryParameters from './__generated__/WorkItemLazyQueryWrapperEntrypointContentQuery$parameters.ts';
import type { WorkItemLazyQueryWrapperEntrypointContentQuery } from './__generated__/WorkItemLazyQueryWrapperEntrypointContentQuery.graphql';
import { getWorkItemLazyQueryWrapperQueryVariables } from './getWorkItemLazyQueryWrapperQueryVariables.tsx';

type WorkItemLazyQueryWrapperEntryPointComponent = EntryPointComponent<
	{
		workItemLazyQueryWrapperQuery: WorkItemLazyQueryWrapperEntrypointContentQuery;
	},
	Record<string, never>,
	WorkItemLazyQueryWrapperProps,
	Record<string, never>
>;

export const workItemLazyQueryWrapperEntryPoint: EntryPoint<
	WorkItemLazyQueryWrapperEntryPointComponent,
	WorkItemLazyQueryWrapperEntryPointParams
> = createEntryPoint({
	root: JSResourceForUserVisible<WorkItemLazyQueryWrapperEntryPointComponent>(
		/* webpackChunkName: "async-work-item-lazy-query-wrapper-entrypoint" */ './WorkItemLazyQueryWrapperEntrypoint.tsx',
		{
			entryFsSsrLiftImportToModule: true,
		},
	),
	getPreloadProps: (entryPointParams) => ({
		queries: {
			workItemLazyQueryWrapperQuery: {
				parameters: workItemLazyQueryWrapperEntrypointContentQueryParameters,
				variables: getWorkItemLazyQueryWrapperQueryVariables(entryPointParams),
				options: {
					fetchPolicy: fg('subtask_visibility_in_new_work_item')
						? 'store-and-network'
						: 'store-or-network',
				},
			},
		},
	}),
});
